import { ChangePasswordActionTypes } from '../../actions/change-password/change-password.actions';
import { AppState } from 'src/app/app.state';
import { ApiResponseSimple } from 'src/app/shared/models/api-response-simple/ApiResponseSimple';

export interface ChangePasswordState {
  error?: ApiResponseSimple;
  loading: boolean;
  loaded: boolean;
}

const initialState: ChangePasswordState = {
  error: null,
  loading: null,
  loaded: null
};

export function changePasswordReducer(state: ChangePasswordState = initialState, action: any): ChangePasswordState {
  switch (action.type) {
    case ChangePasswordActionTypes.REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false
      };
    case ChangePasswordActionTypes.REQUEST_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true
      };

    case ChangePasswordActionTypes.REQUEST_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false
      };

    case ChangePasswordActionTypes.RESET:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: false
      };

    default:
      return state;
  }
}

export const getChangePasswordState = (state: AppState) => state.changePassword;
export const getChangePasswordLoading = (state: ChangePasswordState) => state.loading;
export const getChangePasswordSuccess = (state: ChangePasswordState) => state.loaded;
export const getChangePasswordError = (state: ChangePasswordState) => state.error;
